(() => {
  function initialise(root) {
    root.querySelectorAll('[data-claim-section]').forEach((section) => {
      if (section.dataset.claimReady) return;
      section.dataset.claimReady = 'true';

      const form = section.querySelector('form');
      const status = section.querySelector('[data-claim-status]');
      const useGorgias = section.dataset.gorgiasEnabled === 'true';
      // Claims/returns are Cloudflare-only; never fall back to the retired form host.
      const endpoint = useGorgias ? section.dataset.gorgiasEndpoint : '';
      const requestKind = section.dataset.requestKind === 'return' ? 'return' : 'claim';
      if (!form?.querySelector('[type="submit"]')) return;
      const submitButton = form.querySelector('[type="submit"]');
      submitButton.disabled = true;
      if (!endpoint) {
        if (status) status.textContent = requestKind === 'return' ? (window.sonicStrings?.online_unavailable_return || 'Online returns are temporarily unavailable. Please contact our support team.') : (window.sonicStrings?.online_unavailable_claim || 'Online claims are temporarily unavailable. Please contact our support team.');
      } else {
        const health = new URL(endpoint); health.searchParams.set('action', 'health');
        fetch(health, { credentials: 'omit', signal: AbortSignal.timeout(10000) }).then(async response => {
          if (!response.ok || !(await response.json()).configured) throw Error('Unavailable');
          submitButton.disabled = false;
        }).catch(() => {
          if (status) status.textContent = requestKind === 'return' ? (window.sonicStrings?.online_unavailable_return || 'Online returns are temporarily unavailable. Please contact our support team.') : (window.sonicStrings?.online_unavailable_claim || 'Online claims are temporarily unavailable. Please contact our support team.');
        });
      }
      let posting = false;
      let received = false;
      const transfer = section.querySelector('[data-transfer]');
      const transferTitle = transfer?.querySelector('[data-transfer-title]');
      const transferDescription = transfer?.querySelector('[data-transfer-description]');
      const transferProgress = transfer?.querySelector('[data-transfer-progress]');
      const transferPercent = transfer?.querySelector('[data-transfer-percent]');
      const transferDetail = transfer?.querySelector('[data-transfer-detail]');
      const transferFiles = transfer?.querySelector('[data-transfer-files]');
      const originalSubmitText = submitButton.textContent;
      const text = (key, fallback) => window.sonicStrings?.[key] || fallback;
      const leaveWarning = event => { if (posting) { event.preventDefault(); event.returnValue = ''; } };
      window.addEventListener('beforeunload', leaveWarning);
      const previewUrls = new Set();
      const maxFiles = { videos: 3, images: 6 };
      const formatSize = (bytes) => bytes < 1000000 ? `${Math.ceil(bytes / 1000)}KB` : `${(bytes / 1000000).toFixed(1)}MB`;
      const formatDuration = (seconds) => `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`;
      const inputs = [...section.querySelectorAll('[data-claim-files]')];
      const isVideo = (file) => file.type.startsWith('video/') || /\.(mp4|webm|mov|avi)$/i.test(file.name);
      const routeFiles = (files) => {
        const byKind = { videos: [], images: [] };
        [...files].forEach((file) => byKind[isVideo(file) ? 'videos' : 'images'].push(file));
        Object.entries(byKind).forEach(([kind, items]) => {
          if (!items.length) return;
          const target = inputs.find((input) => input.dataset.claimFiles === kind);
          if (!target) return;
          const transfer = new DataTransfer();
          const seen = new Set();
          [...target.files, ...items].forEach((file) => {
            const key = `${file.name}:${file.size}:${file.lastModified}`;
            if (!seen.has(key)) { seen.add(key); transfer.items.add(file); }
          });
          target.files = transfer.files;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        });
      };
      const previewDialog = document.createElement('dialog');
      previewDialog.className = 'claim__preview-modal';
      previewDialog.setAttribute('aria-label', (window.sonicStrings?.evidence_preview || "Evidence preview"));
      previewDialog.innerHTML = '<div class="claim__preview-header"><h2 class="claim__preview-heading">Evidence preview</h2><div class="claim__preview-navigation"><button type="button" class="claim__preview-nav" data-preview-prev aria-label="Previous file">‹</button><button type="button" class="claim__preview-nav" data-preview-next aria-label="Next file">›</button><button type="button" class="claim__preview-close" aria-label="Close preview">×</button></div></div><div class="claim__preview-content"></div>';
      previewDialog.querySelector('.claim__preview-heading').textContent = (window.sonicStrings?.evidence_preview || "Evidence preview");
      previewDialog.querySelector("[data-preview-prev]").setAttribute("aria-label", (window.sonicStrings?.previous_file || "Previous file"));
      previewDialog.querySelector("[data-preview-next]").setAttribute("aria-label", (window.sonicStrings?.next_file || "Next file"));
      previewDialog.querySelector(".claim__preview-close").setAttribute("aria-label", (window.sonicStrings?.close_preview || "Close preview"));
      section.append(previewDialog);
      const previewContent = previewDialog.querySelector('.claim__preview-content');
      const previewClose = previewDialog.querySelector('.claim__preview-close');
      const previewPrevious = previewDialog.querySelector('[data-preview-prev]');
      const previewNext = previewDialog.querySelector('[data-preview-next]');
      let previewTrigger = null;
      const closePreview = () => {
        if (previewDialog.open) previewDialog.close();
        else previewDialog.removeAttribute('open');
        previewContent.replaceChildren();
        previewTrigger?.focus();
        previewTrigger = null;
      };
      previewClose.addEventListener('click', closePreview);
      const movePreview = (direction) => {
        const current = previewTrigger?.closest('li');
        const next = current?.[direction === -1 ? 'previousElementSibling' : 'nextElementSibling'];
        next?.querySelector('.claim__file-preview')?.click();
      };
      previewPrevious.addEventListener('click', () => movePreview(-1));
      previewNext.addEventListener('click', () => movePreview(1));
      previewDialog.addEventListener('click', (event) => {
        if (event.target === previewDialog) closePreview();
      });
      previewDialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closePreview();
      });

      const showError = (input) => {
        const error = document.getElementById(`${input.id}-error`);
        if (!error) return;
        const invalid = !input.validity.valid;
        input.setAttribute('aria-invalid', String(invalid));
        error.hidden = !invalid;
        error.textContent = invalid ? input.validationMessage : '';
      };

      form.addEventListener('invalid', (event) => showError(event.target), true);
      form.addEventListener('input', (event) => {
        const input = event.target;
        if (input.matches('input[type="text"][required], textarea[required]')) {
          input.setCustomValidity(input.value.trim() ? '' : (window.sonicStrings?.field_required || "Please complete this field."));
        }
        if (input.getAttribute('aria-invalid') === 'true') showError(input);
      });
      form.addEventListener('change', (event) => {
        showError(event.target);
        const input = event.target;
        if (!input.matches('[data-claim-files]')) return;
        const videos = input.dataset.claimFiles === 'videos';
        const extensions = videos ? /\.(mp4|webm|mov|avi)$/i : /\.(png|jpe?g|gif)$/i;
        const maxSize = videos ? 20_000_000 : 4 * 1024 * 1024;
        const files = [...input.files];
        const matching = files.filter((file) => isVideo(file) === videos);
        if (matching.length !== files.length && !input.dataset.routing) {
          input.dataset.routing = 'true';
          routeFiles(files.filter((file) => isVideo(file) !== videos));
          const transfer = new DataTransfer();
          matching.forEach((file) => transfer.items.add(file));
          input.files = transfer.files;
          input.dataset.routing = '';
        }
        const totalSize = files.reduce((total, file) => total + file.size, 0);
        const bad = files.find((file) => !extensions.test(file.name) || file.size > maxSize || file.size === 0);
        const tooMany = files.length > maxFiles[input.dataset.claimFiles];
        input.setCustomValidity(bad ? (videos ? (window.sonicStrings?.invalid_video || "“[file]” must be a supported video up to 20MB and cannot be empty.") : (window.sonicStrings?.invalid_image || "“[file]” must be a supported image up to 4MB and cannot be empty.")).replaceAll("[file]", () => bad.name) : tooMany ? (videos ? (window.sonicStrings?.too_many_videos || "Please select no more than [count] videos.") : (window.sonicStrings?.too_many_images || "Please select no more than [count] images.")).replaceAll("[count]", () => maxFiles[input.dataset.claimFiles]) : totalSize > 120 * 1024 * 1024 ? (window.sonicStrings?.files_too_large || "Your selected files are too large. Please keep the total upload under 120MB.") : '');
        showError(input);
        const list = input.closest('[data-claim-upload]')?.querySelector('.claim__files');
        if (list) {
          list.querySelectorAll('[data-preview-url]').forEach((node) => {
            previewUrls.delete(node.dataset.previewUrl);
            URL.revokeObjectURL(node.dataset.previewUrl);
          });
          list.replaceChildren(...files.map((file) => {
            const item = document.createElement('li');
            const previewUrl = URL.createObjectURL(file);
            previewUrls.add(previewUrl);
            item.dataset.previewUrl = previewUrl;
            item.dataset.fileName = file.name;
            item.dataset.fileSize = formatSize(file.size);
            const media = document.createElement(videos ? 'video' : 'img');
            media.src = previewUrl;
            media.className = 'claim__file-preview';
            media.alt = videos ? (window.sonicStrings?.preview_of || "Preview of [file]").replaceAll("[file]", () => file.name) : file.name;
            media.tabIndex = 0;
            media.setAttribute('role', 'button');
            media.setAttribute('aria-label', (window.sonicStrings?.open_preview || "Open preview of [file]").replaceAll("[file]", () => file.name));
            media.addEventListener('keydown', (event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                media.click();
              }
            });
            if (videos) {
              media.preload = 'metadata';
              media.playsInline = true;
              media.muted = true;
              const capturePoster = () => {
                if (media.videoWidth === 0 || media.videoHeight === 0) return;
                item.dataset.dimensions = `${media.videoWidth} × ${media.videoHeight}`;
                if (Number.isFinite(media.duration)) item.dataset.duration = formatDuration(media.duration);
                const canvas = document.createElement('canvas');
                canvas.width = media.videoWidth;
                canvas.height = media.videoHeight;
                canvas.getContext('2d')?.drawImage(media, 0, 0, canvas.width, canvas.height);
                try { media.poster = canvas.toDataURL('image/jpeg', 0.82); } catch (error) { /* poster is optional */ }
              };
              media.addEventListener('loadedmetadata', () => {
                if (media.duration > 0.1) {
                  media.currentTime = Math.min(0.1, media.duration / 2);
                  media.addEventListener('seeked', capturePoster, { once: true });
                } else {
                  media.addEventListener('loadeddata', capturePoster, { once: true });
                }
              }, { once: true });
            }
            media.addEventListener('load', () => {
              if (media.naturalWidth) item.dataset.dimensions = `${media.naturalWidth} × ${media.naturalHeight}`;
            }, { once: true });
            const caption = document.createElement('span');
            caption.className = 'claim__file-name';
            caption.textContent = `${file.name} (${formatSize(file.size)})`;
            const remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'claim__remove';
            remove.setAttribute('aria-label', (window.sonicStrings?.remove_file || "Remove [file]").replaceAll("[file]", () => file.name));
            remove.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m-9 0 1 13h8l1-13M10 11v5m4-5v5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            const previewButton = document.createElement('button');
            previewButton.type = 'button';
            previewButton.className = 'claim__preview-action';
            previewButton.setAttribute('aria-label', (window.sonicStrings?.preview_file || "Preview [file]").replaceAll("[file]", () => file.name));
            previewButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" fill="none" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="12" r="2.5" fill="none" stroke="currentColor" stroke-width="1.7"/></svg>';
            const actions = document.createElement('span');
            actions.className = 'claim__file-actions';
            actions.append(previewButton, remove);
            const progress = document.createElement('progress');
            progress.className = 'claim__file-progress';
            progress.max = 100;
            progress.value = 0;
            progress.hidden = true;
            progress.setAttribute('aria-label', (window.sonicStrings?.upload_progress || "Upload progress for [file]").replaceAll("[file]", () => file.name));
            item.append(media, caption, actions, progress);
            return item;
          }));
          list.onclick = (event) => {
            const previewAction = event.target.closest('.claim__preview-action');
            const media = previewAction
              ? previewAction.closest('li')?.querySelector('.claim__file-preview')
              : event.target.closest('.claim__file-preview');
            if (previewAction) {
              event.preventDefault();
              media?.click();
              return;
            }
            if (media) {
              event.preventDefault();
              const item = media.closest('li');
              previewTrigger = media;
              const siblings = [...media.closest('.claim__files').children];
              const currentIndex = siblings.indexOf(item);
              previewPrevious.disabled = currentIndex <= 0;
              previewNext.disabled = currentIndex === siblings.length - 1;
              const fullPreview = document.createElement(media.tagName.toLowerCase());
              fullPreview.src = media.src;
              fullPreview.className = 'claim__preview-media';
              fullPreview.alt = media.alt;
              if (media.tagName === 'VIDEO') {
                fullPreview.controls = true;
                fullPreview.autoplay = true;
                fullPreview.playsInline = true;
              }
              const metadata = document.createElement('p');
              metadata.className = 'claim__preview-meta';
              const updateMetadata = () => {
                const parts = [item.dataset.fileName, item.dataset.fileSize, item.dataset.duration, item.dataset.dimensions].filter(Boolean);
                metadata.replaceChildren(...parts.map((part, index) => {
                  const tag = document.createElement('span');
                  tag.className = `claim__preview-meta-item${index === 0 ? ' claim__preview-meta-item--name' : ''}`;
                  tag.textContent = part;
                  return tag;
                }));
              };
              updateMetadata();
              fullPreview.addEventListener('loadedmetadata', () => {
                if (fullPreview.videoWidth) item.dataset.dimensions = `${fullPreview.videoWidth} × ${fullPreview.videoHeight}`;
                if (Number.isFinite(fullPreview.duration)) item.dataset.duration = formatDuration(fullPreview.duration);
                updateMetadata();
              }, { once: true });
              fullPreview.addEventListener('load', () => {
                if (fullPreview.naturalWidth) item.dataset.dimensions = `${fullPreview.naturalWidth} × ${fullPreview.naturalHeight}`;
                updateMetadata();
              }, { once: true });
              previewContent.replaceChildren(fullPreview, metadata);
              if (typeof previewDialog.showModal === 'function') previewDialog.showModal();
              else previewDialog.setAttribute('open', '');
              previewClose.focus();
              return;
            }
            const remove = event.target.closest('.claim__remove');
            if (!remove) return;
            const item = remove.closest('li');
            const index = [...list.children].indexOf(item);
            const transfer = new DataTransfer();
            [...input.files].forEach((file, fileIndex) => {
              if (fileIndex !== index) transfer.items.add(file);
            });
            input.files = transfer.files;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          };
        }
      });

      section.querySelectorAll('[data-claim-dropzone]').forEach((dropzone) => {
        const input = dropzone.querySelector('[data-claim-files]');
        if (!input) return;
        ['dragenter', 'dragover'].forEach((type) => dropzone.addEventListener(type, (event) => {
          event.preventDefault();
          dropzone.classList.add('is-dragging');
        }));
        ['dragleave', 'drop'].forEach((type) => dropzone.addEventListener(type, (event) => {
          event.preventDefault();
          dropzone.classList.remove('is-dragging');
        }));
        dropzone.addEventListener('drop', (event) => {
          routeFiles([...input.files, ...event.dataTransfer.files]);
        });
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (received || posting || !endpoint || !form.checkValidity()) {
          if (!form.checkValidity()) form.reportValidity();
          if (!endpoint && status) status.textContent = (requestKind === 'return' ? (window.sonicStrings?.online_unavailable_return || "Online returns are temporarily unavailable. Please contact our support team.") : (window.sonicStrings?.online_unavailable_claim || "Online claims are temporarily unavailable. Please contact our support team."));
          return;
        }
        posting = true;
        const submit = form.querySelector('[type="submit"]');
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        const lockedControls = [...form.elements].filter(control => !control.disabled && control !== submit);
        let receipt;
        try {
          const fields = new FormData(form);
          if (fields.get('website')) throw new Error('Invalid submission');
          if (useGorgias) {
            const value = name => String(fields.get(name) || '').trim();
            const files = inputs.flatMap(input => [...input.files]);
            const requestFields = { kind: requestKind, first_name: value('contact[First name]'), last_name: value('contact[Last name]'), email: value('contact[email]'), product: value('contact[Product]'), order_number: value('contact[Order number]'), reason: value(requestKind === 'return' ? 'contact[Return reason]' : 'contact[Claim reason]'), description: value('contact[body]'), confirm: value('contact[Used in line with instruction manual]') === 'Yes', website: value('website') };
            if (value('contact[Variant ID]')) Object.assign(requestFields, { product_id: value('contact[Product ID]'), variant_id: value('contact[Variant ID]'), sku: value('contact[SKU]'), colour: value('contact[Colour]') });
            if (requestKind === 'return') requestFields.condition = value('contact[Product condition]');
            else requestFields.purchase_location = value('contact[Purchase source]');
            lockedControls.forEach(control => { control.disabled = true; });
            if (transfer) {
              transfer.hidden = false;
              transfer.dataset.state = 'sending';
              transferProgress.value = 0;
              transferPercent.textContent = '0%';
              transfer.querySelector('[data-transfer-reference]').hidden = true;
              form.querySelectorAll('.claim__actions, .claim__footer > .claim__intro').forEach(node => { node.hidden = true; });
              transferFiles.replaceChildren(...files.map(file => {
                const row = document.createElement('li');
                const name = document.createElement('span'); name.textContent = file.name;
                const percent = document.createElement('span'); percent.textContent = '0%';
                row.append(name, percent); return row;
              }));
            }
            const titles = {
              preparing: text('transfer_preparing', 'Preparing your request'),
              verification: text('verification_wait', 'Please complete the verification…'),
              uploading: text('transfer_uploading', 'Uploading your files'),
              retrying: text('transfer_retrying', 'Reconnecting your upload'),
              saving: text('transfer_saving', 'Saving your request')
            };
            submit.textContent = text('transfer_sending_button', 'Sending…');
            receipt = await window.SonicWarranty.submit({ form, endpoint, sitekey: section.dataset.turnstileSitekey,
              fields: requestFields, files,
              onProgress: ({ stage, loaded = 0, total = 0, fileBytes = [] }) => {
                const title = titles[stage];
                if (status && status.textContent !== title) status.textContent = title;
                if (!transfer) return;
                transferTitle.textContent = title;
                if (stage === 'preparing') {
                  transferTitle.focus({ preventScroll: true });
                  transfer.scrollIntoView({ behavior: 'instant', block: 'center' });
                }
                transferDescription.textContent = stage === 'saving'
                  ? text('transfer_saving_hint', 'Your files are uploaded. We’re safely saving your details now.')
                  : text('transfer_keep_open', 'Please keep this page open until your request is received.');
                transferDetail.hidden = !total;
                if (total) {
                  const percent = Math.min(100, Math.floor(loaded / total * 100));
                  transferProgress.value = percent;
                  transferPercent.textContent = `${percent}%`;
                  transferDetail.textContent = text('transfer_bytes', '[loaded] of [total] uploaded').replaceAll('[loaded]', () => formatSize(loaded)).replaceAll('[total]', () => formatSize(total));
                  fileBytes.forEach((bytes, index) => {
                    const percent = Math.min(100, Math.floor(bytes / files[index].size * 100));
                    transferFiles.children[index].lastElementChild.textContent = `${percent}%`;
                    const progress = section.querySelectorAll('.claim__file-progress')[index];
                    if (progress) { progress.hidden = false; progress.value = percent; }
                  });
                }
                transferProgress.hidden = transferPercent.hidden = !files.length;
              }
            });
          }
          received = true;
          if (transfer) {
            transfer.dataset.state = receipt.state === 'review' ? 'review' : 'received';
            transferTitle.textContent = text('transfer_received', 'Request received');
            transferDescription.textContent = receipt.state === 'review'
              ? text('transfer_review', 'Your request is safely saved, but delivery needs checking. Please contact our support team with the reference below. Do not submit it again.')
              : text('transfer_complete', 'Your details and any files are safely received. Our support team will review your request and contact you by email. You can close this page.');
            transferProgress.hidden = transferPercent.hidden = transferDetail.hidden = transferFiles.hidden = true;
            transfer.querySelector('[data-transfer-check]').toggleAttribute('hidden', receipt.state === 'review');
            const reference = transfer.querySelector('[data-transfer-reference]');
            reference.textContent = text('transfer_reference', 'Your reference: [reference]').replaceAll('[reference]', () => receipt.reference);
            reference.hidden = false;
            form.querySelectorAll('.claim__section:not(.claim__footer), .claim__actions, .claim__footer > .claim__intro').forEach(node => { node.hidden = true; });
            transferTitle.focus({ preventScroll: true });
            transfer.scrollIntoView({ behavior: 'instant', block: 'center' });
          }
          form.reset();
          section.querySelectorAll('.claim__files').forEach((list) => {
            list.querySelectorAll('[data-preview-url]').forEach((node) => {
              previewUrls.delete(node.dataset.previewUrl);
              URL.revokeObjectURL(node.dataset.previewUrl);
            });
          list.replaceChildren();
          });
          if (status) status.textContent = text('transfer_received', 'Request received');
        } catch (error) {
          if (status) status.textContent = error.warranty ? (error.customerMessage || error.message) : (requestKind === 'return' ? (window.sonicStrings?.request_error_return || "We couldn’t submit your return request right now. Please try again.") : (window.sonicStrings?.request_error_claim || "We couldn’t submit your claim right now. Please try again."));
          if (transfer) {
            transfer.dataset.state = 'error';
            transferTitle.textContent = text('transfer_interrupted', 'Your request is not yet confirmed');
            transferDescription.textContent = text('transfer_retry_hint', 'Your details and selected files are still here. Keep this page open and retry to continue the same request without resending completed upload parts.');
            transferTitle.focus({ preventScroll: true });
            transfer.scrollIntoView({ behavior: 'instant', block: 'center' });
          }
        } finally {
          posting = false;
          if (!received) {
            lockedControls.forEach(control => { control.disabled = false; });
            form.querySelectorAll('.claim__actions, .claim__footer > .claim__intro').forEach(node => { node.hidden = false; });
          }
          submit.disabled = received;
          submit.textContent = received ? originalSubmitText : text('transfer_retry_button', 'Retry request');
          submit.removeAttribute('aria-busy');
        }
      });

      window.addEventListener('pagehide', () => {
        window.removeEventListener('beforeunload', leaveWarning);
        previewUrls.forEach((url) => URL.revokeObjectURL(url));
        previewDialog.remove();
      }, { once: true });
    });
  }

  initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
